export const animateFlowers = () => {
    const flowers = document.querySelectorAll('.group-4');

    let delay = 0;

    flowers.forEach(flower => {
        setTimeout(() => {
            flower.classList.add('on');
            flower.classList.remove("hide");
        }, delay += 200);
    })
}